var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 51,
    viewBox: "0 0 163 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5093 0.319336H80.6318V5.19677H85.5093V0.319336Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.682 24.7101L155.023 28.3691L158.682 32.0282L162.342 28.3691L158.682 24.7101Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8509 43.0021L28.1919 46.6611L31.8509 50.3202L35.51 46.6611L31.8509 43.0021Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3882 16.1819V40.5607H107.462L109.901 38.1212V30.8075L107.462 28.3713L109.901 25.9318V18.6114L107.462 16.1719H90.3882V16.1819ZM97.7052 30.8159H102.583V35.685H97.7052V30.8075M97.7052 25.9301V21.0527H102.583V25.9301H97.7052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4603 8.85733H85.5093V8.24619L84.8998 7.63672H81.2413L80.6318 8.24619V13.1253L81.2413 13.7348H84.8998L85.5093 13.1253V12.5158H82.4603V11.2952H85.5093V10.0763H82.4603V8.85733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0252 7.63672V10.0763H76.1968V7.63672H74.9762L74.3667 8.24619V13.1253L74.9762 13.7348H76.1968V11.2952H78.0252V13.7348H79.2441L79.8553 13.1253V8.24619L79.2441 7.63672H78.0252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0465 7.63672L68.437 8.24786V8.85733H70.2654V13.1253L70.8749 13.7348H71.4844L72.0955 13.1253V8.85733H73.9239V8.24619L73.3144 7.63672H69.0465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58262 16.1738L0.143066 18.6117V28.3683L2.58262 30.8078H12.3375V35.6853H7.46006V33.2474H0.143066V38.1248L2.58262 40.5644H17.2166L19.6562 38.1248V28.3683L17.2166 25.9304H7.46006V21.0513H12.3375V23.4908H19.6562V18.6117L17.2166 16.1738H2.58262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.437 16.1819V40.5607H85.5105L87.9501 38.1212V18.6114L85.5105 16.1719H68.437V16.1819ZM75.754 21.0593H80.6264V35.685H75.754V21.0593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.779 16.1819L112.339 18.6214V38.1262L114.779 40.5607H129.413L131.852 38.1212V18.6114L129.413 16.1719H114.779V16.1819ZM119.656 21.0593H124.542V35.685H119.656V21.0593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.486 16.1738V23.4908L144.047 25.9304L141.609 23.4908V16.1738H136.73L134.29 18.6117V25.9304L136.73 28.3683L134.29 30.8078V38.1248L136.73 40.5644H141.609V33.2474L144.047 30.8078L146.486 33.2474V40.5644H151.364L153.803 38.1248V30.8078L151.364 28.3683L153.803 25.9304V18.6117L151.364 16.1738H146.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6809 16.1738V23.4908L51.3639 16.1738H46.4848L44.0469 18.6117V38.1248L46.4848 40.5644H51.3639V25.9304L58.6809 33.2474V40.5644H63.5583L65.9979 38.1248V18.6117L63.5583 16.1738H58.6809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1678 16.1819H24.5338L22.0942 18.6214V38.1262L24.5338 40.5607H29.4112V30.8092H34.2887V40.5607H39.1661L41.6057 38.1212V18.6114L39.1661 16.1719L39.1678 16.1819ZM31.8508 27.119L28.224 23.4922L31.8508 19.8654L35.4776 23.4922L31.8508 27.119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.198,
    height: 50,
    fill: "white",
    transform: "translate(0.143066 0.319336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.523e9967ef969293d9bfee77e1e577af.svg";
export { ForwardRef as ReactComponent };